import Vue from 'vue';
import VueCookie from 'vue-cookies';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Element from 'element-ui';
import ElTreeSelect from 'el-tree-select';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import i18n from './i18n';
import 'font-awesome/css/font-awesome.min.css';

const stripCorsBreakingHeaders = (headers) => {
  if (!headers || typeof headers !== 'object') {
    return;
  }
  const nextHeaders = headers;
  delete nextHeaders['Access-Control-Allow-Origin'];
  delete nextHeaders['access-control-allow-origin'];
  delete nextHeaders['Cache-Control'];
  delete nextHeaders['cache-control'];
  ['common', 'delete', 'get', 'head', 'post', 'put', 'patch'].forEach((key) => {
    if (nextHeaders[key] && typeof nextHeaders[key] === 'object') {
      stripCorsBreakingHeaders(nextHeaders[key]);
    }
  });
};

axios.interceptors.request.use((config) => {
  const request = config;
  stripCorsBreakingHeaders(request.headers);
  if (process.env.NODE_ENV === 'production') {
    const requestUrl = request.url || '';
    const apiEndpoint = (process.env.VUE_APP_API_ENDPOINT || '').replace(/\/$/, '');
    if (requestUrl.startsWith('/api/')) {
      request.url = `${apiEndpoint}${requestUrl.slice(4)}`;
    } else if (requestUrl.startsWith('api/')) {
      request.url = `${apiEndpoint}/${requestUrl.slice(4)}`;
    } else if (requestUrl.startsWith('/apis/')) {
      request.url = `https://api.adarshah.org/plugins${requestUrl.slice(5)}`;
    } else if (requestUrl.startsWith('/dharmaAPI/')) {
      request.url = `https://api.adarshah.org/plugins${requestUrl.slice(11)}`;
    }
  }
  return request;
});

Vue.use(Element);
Vue.use(ElTreeSelect);
Vue.use(VueCookie, VueAxios, axios);

Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
